import { useCallback } from 'react';
import _ from 'lodash';

export function createUseSelectedProps({ StateContext }) {
  return function useSelectedProps(selectors, equalityFunction = Object.is) {
    const isEqual = useCallback(
      (oldSelection, newSelection) =>
        oldSelection.length === newSelection.length && newSelection.every((value, index) => equalityFunction(value, oldSelection[index])),
      [equalityFunction],
    );
    const wrappedSelectors = Array.isArray(selectors) ? selectors : [selectors];
    const selector = useCallback(
      (state) => wrappedSelectors.map(selector => _getSelectedValue(state, selector)),
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [...wrappedSelectors],
    );
    return StateContext.useSelectedState(selector, isEqual);
  };
}

const _getSelectedValue = (newState, selector) => {
  const selectorType = typeof selector;
  if (selectorType === 'function') {
    return selector(newState || {});
  } else if (selectorType === 'string') {
    return _.get(newState, selector);
  } else {
    throw new Error(`Unsupported selector type, found ${selectorType} for ${selector}`);
  }
};
